module.exports = __webpack_public_path__ + "static/media/fox.855126c1.jpg";